import EachSymbolShape, {
  symbolShapePropTypes,
  symbolShapeBaseDefaults,
} from "./EachSymbolShape";

// Check shape definition (from ChartIQ) — config sobre EachSymbolShape
const CHECK_DIMENSION = [8, 9];

// Check path centered at origin
// Original ChartIQ path: M 1,5 L 0,6 L 2,8 L 7,1 L 6,0 L 2,6 L 1,5
const getCheckPath = ([w, h]) => {
  const cx = (w - 1) / 2; // 3.5
  const cy = (h - 1) / 2; // 4
  return `M ${1 - cx},${5 - cy} L ${0 - cx},${6 - cy} L ${2 - cx},${8 - cy} L ${7 - cx},${1 - cy} L ${6 - cx},${0 - cy} L ${2 - cx},${6 - cy} Z`;
};

class EachCheck extends EachSymbolShape {}

EachCheck.propTypes = symbolShapePropTypes;

EachCheck.defaultProps = {
  ...symbolShapeBaseDefaults,
  dimension: CHECK_DIMENSION,
  getPath: getCheckPath,
  stroke: { color: "#4CAF50", width: 2, opacity: 1, dash: "Solid" },
  fill: { color: "#4CAF50", opacity: 0.6 },
};

export default EachCheck;
